/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/alt-text */
import React, { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from "yup";
import {
  UserProfileInfo,
  UserLabel,
} from '../Profile/Profile.style';
import {
  ActionGroup,
  Button,
} from '../Generals/stylesheets/Button.style';
import FormInput from '../Generals/FormInput/FormInput';
import { ModalHeader, ModalCLose } from '../Generals/stylesheets/General.style';
import ResponsiveModal from '../common/responsiveModal/ResponsiveModal';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '30px',
    width: 'calc(100% - 30px)',
    maxWidth: '640px',
    margin: '0 auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    border: 'none',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999,
  },
};

class ProfileEditForm extends PureComponent {
  static propTypes = {
    user: PropTypes.objectOf(PropTypes.any).isRequired,
    submitUserEdit: PropTypes.func,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  }

  onClose = () => {
    const { onClose } = this.props;
    onClose();
  }

  handleSubmit = (values) => {
    const { submitUserEdit } = this.props;
    submitUserEdit(values);
  }

  render() {
    const { user } = this.props;
    const { isOpen } = this.props;
    const { first_name, last_name, email } = user;
    const initialValues = {
      first_name,
      last_name,
      email,
    };
    const ProfileSchema = Yup.object().shape({
      first_name: Yup.string().trim().required('First name is required'),
      last_name: Yup.string().trim().required('Last name is required'),
      email: Yup.string().trim().email('Enter a valid email address (e.g., user@example.com)').required('Email address is required'),
    });

    return (
      <ResponsiveModal
        isOpen={isOpen}
        onRequestClose={this.onClose}
        style={modalStyles}
        ariaHideApp={false}
        contentLabel="Edit profile"
      >
        <ModalHeader>
          <p>Edit Profile</p>
          <ModalCLose className="chalktalk-close" onClick={this.onClose} />
        </ModalHeader>
        <Formik
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          validationSchema={ProfileSchema}
        >
          <Form>
            <UserProfileInfo>
              <UserLabel>First name</UserLabel>
              <FormInput
                type="text"
                name="first_name"
                aria-label="First name"
                autoComplete="given-name"
              />
            </UserProfileInfo>

            <UserProfileInfo>
              <UserLabel>Last name</UserLabel>
              <FormInput
                type="text"
                name="last_name"
                aria-label="Last name"
                autoComplete="family-name"
              />
            </UserProfileInfo>

            <UserProfileInfo>
              <UserLabel>Email</UserLabel>
              <FormInput
                type="text"
                name="email"
                aria-label="Email"
                autoComplete="email"
              />
            </UserProfileInfo>

            <ActionGroup center marginTop>
              <Button submit type="submit">Submit</Button>
              <Button onClick={this.onClose}>Cancel</Button>
            </ActionGroup>
          </Form>
        </Formik>
      </ResponsiveModal>
    );
  }
}

export default ProfileEditForm;
